import {
  CrearSalaMultijugadorDTO,
  UnirseSalaDTO,
  SalaMultijugadorResponseDTO,
  RankingSalaDTO
} from '../types/multijugador';
import api from './api';
import { FinalizarExamenRequest } from '../types/examen.types';

export class MultijugadorService {
  
  /**
   * Crear una nueva sala multijugador
   */
  static async crearSala(datos: CrearSalaMultijugadorDTO): Promise<SalaMultijugadorResponseDTO> {
    try {
      const response = await api.post('/api/salas/crear', datos);
      return response.data;
    } catch (error: any) {
      console.error('Error al crear sala:', error);
      throw new Error(error.response?.data?.message || 'Error al crear la sala');
    }
  }

  /**
   * Unirse a una sala existente
   */
  static async unirseASala(datos: UnirseSalaDTO): Promise<SalaMultijugadorResponseDTO> {
    try {
      const response = await api.post('/api/salas/unirse', datos);
      return response.data;
    } catch (error: any) {
      console.error('Error al unirse a sala:', error);
      throw new Error(error.response?.data?.message || 'Error al unirse a la sala');
    }
  }

  /**
   * Obtener información de una sala
   */
  static async obtenerSala(codigoSala: string): Promise<SalaMultijugadorResponseDTO> {
    try {
      const response = await api.get(`/api/salas/${codigoSala}`);
      return response.data;
    } catch (error: any) {
      console.error('Error al obtener sala:', error);
      throw new Error(error.response?.data?.message || 'Error al obtener información de la sala');
    }
  }

  /**
   * Iniciar examen en la sala (solo creador)
   */
  static async iniciarExamen(codigoSala: string): Promise<void> {
    try {
      await api.post(`/api/salas/${codigoSala}/iniciar`);
    } catch (error: any) {
      console.error('Error al iniciar examen:', error);
      throw new Error(error.response?.data?.message || 'Error al iniciar el examen');
    }
  }

  /**
   * Finalizar participación en sala multijugador
   */
  static async finalizarParticipacion(
    codigoSala: string,
    datos: FinalizarExamenRequest
  ): Promise<RankingSalaDTO> {
    try {
      const response = await api.post(`/api/salas/${codigoSala}/finalizar`, datos);
      return response.data;
    } catch (error: any) {
      console.error('Error al finalizar participación:', error);
      throw new Error(error.response?.data?.message || 'Error al finalizar participación');
    }
  }

  /**
   * Obtener ranking actual de la sala
   */
  static async obtenerRanking(codigoSala: string): Promise<RankingSalaDTO> {
    try {
      const response = await api.get(`/api/salas/${codigoSala}/ranking`);
      return response.data;
    } catch (error: any) {
      console.error('Error al obtener ranking:', error);
      throw new Error(error.response?.data?.message || 'Error al obtener el ranking');
    }
  }

  /**
   * Abandonar sala
   */
  static async abandonarSala(codigoSala: string): Promise<void> {
    try {
      await api.post(`/api/salas/${codigoSala}/abandonar`);
    } catch (error: any) {
      console.error('Error al abandonar sala:', error);
      throw new Error(error.response?.data?.message || 'Error al abandonar la sala');
    }
  }

  /**
   * Obtener sala activa del usuario
   */
  static async obtenerMiSalaActiva(): Promise<SalaMultijugadorResponseDTO | null> {
    try {
      const response = await api.get('/api/salas/mi-sala-activa');
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 204) {
        // No content - no hay sala activa
        return null;
      }
      console.error('Error al obtener sala activa:', error);
      throw new Error(error.response?.data?.message || 'Error al obtener sala activa');
    }
  }

  /**
   * Cerrar sala activa del usuario
   */
  static async cerrarMiSalaActiva(): Promise<void> {
    try {
      await api.post('/api/salas/cerrar-mi-sala-activa');
    } catch (error: any) {
      console.error('Error al cerrar sala activa:', error);
      throw new Error(error.response?.data?.message || 'Error al cerrar sala activa');
    }
  }

  /**
   * Health check del servicio multijugador
   */
  static async healthCheck(): Promise<string> {
    console.log('🐈 [HEALTH-CHECK] Iniciando verificación de servicio multijugador...');
    try {
      console.log('🌐 [HEALTH-CHECK] Haciendo request a: /api/salas/health');
      console.log('🔗 [HEALTH-CHECK] Base URL del API:', api.defaults.baseURL);
      
      const response = await api.get('/api/salas/health');
      console.log('✅ [HEALTH-CHECK] Respuesta exitosa:', response.data);
      console.log('📊 [HEALTH-CHECK] Status:', response.status);
      return response.data;
    } catch (error: any) {
      console.error('❌ [HEALTH-CHECK] Error en health check:', error);
      console.error('📊 [HEALTH-CHECK] Error details:');
      console.error('   - message:', error.message);
      console.error('   - status:', error.response?.status);
      console.error('   - statusText:', error.response?.statusText);
      console.error('   - data:', error.response?.data);
      console.error('   - config.url:', error.config?.url);
      console.error('   - config.baseURL:', error.config?.baseURL);
      throw new Error('Servicio multijugador no disponible');
    }
  }

  /**
   * Invitar un usuario a la sala
   */
  static async invitarUsuario(codigoSala: string, usuarioId: number): Promise<void> {
    try {
      await api.post(`/api/salas/${codigoSala}/invitar/${usuarioId}`);
    } catch (error: any) {
      console.error('Error al invitar usuario:', error);
      throw new Error(error.response?.data?.message || 'Error al enviar la invitación');
    }
  }
}
